<nz-card>
<div class="action-group top-sticky">
    <div style="display: flex; justify-content: space-between">
      <nz-input-group [nzSuffix]="suffixIcon"
                      style="width: 300px">
        <input type="text" nz-input placeholder="Tìm kiếm menu" [(ngModel)]="searchText" (input)="handleInput($event)"/>
        <ng-template #suffixIcon>
          <span nz-icon nzType="search"></span>
        </ng-template>
      </nz-input-group>

      <div class="d-flex gap-1">
        <button nz-button (click)="doAction('ADD')" nzType="primary" class="mr-2">
          <span nz-icon nzType="plus"></span>
          Thêm mới
        </button>
        <button nz-button (click)="doAction('DELETE')" nzType="danger" class="mr-2">
          <span nz-icon nzType="delete"></span>
          Xóa
        </button>
        <button nz-button (click)="getList(true)" nzType="danger" >
          <span nz-icon nzType="sync"></span>
          Làm mới
        </button>
      </div>
    </div>
  </div>
  <div nz-row class="menu-page">
    <div class="menu-tree" nz-col nzMd="7">
      <div style="display: flex; justify-content: space-between">
        <p><label class="font-weight-bold">DANH SÁCH MENU</label></p>
        <p (click)="doAction('EXPAND_COLLAPSE_ALL')">Đóng/Mở<i nz-icon nzType=""></i></p>
      </div>

      <nz-spin [nzSpinning]="isSpinning">
        <nz-tree-view  *ngIf="dataSource.getData().length > 0" [nzTreeControl]="treeControl" [nzDataSource]="dataSource">
          <nz-tree-node *nzTreeNodeDef="let node" nzTreeNodeIndentLine>
            <nz-tree-node-option
              [nzSelected]="selectedMenu.isSelected(node)"
              (nzClick)="selectedMenu.toggle(node)"
            >
          <span class="menu-item" [ngClass]="node.data.enable ? '' : 'disable'">
            <span *ngIf="node.level == 0">
              <!--  begin::ICON -->
                <i-tabler *ngIf="node.data.icon" [name]="node.data.icon" class="tb-icon tb-icon-m center"></i-tabler>
              <!--  end::ICON -->
            </span>
            <label class="m-2" [innerHTML]="node.data.name | highlight: searchText"></label>
          </span>
            </nz-tree-node-option>
          </nz-tree-node>

          <nz-tree-node *nzTreeNodeDef="let node; when: hasChild" nzTreeNodeIndentLine>
            <nz-tree-node-option
              [nzSelected]="selectedMenu.isSelected(node)"
              (nzClick)="selectedMenu.toggle(node)"
            >
            <span class="menu-item" [ngClass]="node.data.enable ? '' : 'disable'">
              <span *ngIf="node.level == 0">
                <!--  begin::ICON -->
                  <i-tabler *ngIf="node.data.icon" [name]="node.data.icon" class="tb-icon tb-icon-m center"></i-tabler>
                <!--  end::ICON -->
              </span>
              <label class="m-2" [innerHTML]="node.name | highlight: searchText"></label>
            </span>
              <nz-tree-node-toggle>
          <span
            nz-icon
            [nzType]="treeControl.isExpanded(node) ? 'minus-square' : 'plus-square'"
            nzTheme="outline"
          ></span>
              </nz-tree-node-toggle>
            </nz-tree-node-option>

          </nz-tree-node>
        </nz-tree-view>
        <app-empty *ngIf="dataSource.getData().length == 0"></app-empty>
      </nz-spin>
    </div>
    <div nz-col nzMd="10" nzOffset="1">
      <div style="display: flex; justify-content: space-between">
        <p><label class="font-weight-bold">THÔNG TIN MENU CHI TIẾT</label></p>
      </div>
      <app-config-menu *ngIf="!selectedMenu.isEmpty()" [data]="selectedMenu.selected[0].data" [menus]="menus"
                       [mode]="MODE.EDIT" (reloadEvent)="getList($event.refresh, $event.key)"></app-config-menu>
      <app-empty *ngIf="selectedMenu.isEmpty()"></app-empty>
    </div>
    <div nz-col nzMd="5" nzOffset="1" *ngIf="selectedMenu.hasValue()">
      <p><label class="font-weight-bold">THÔNG TIN ROLE LIÊN QUAN</label></p>

      <br>
      <ul nz-list [nzDataSource]="ROLE_TYPES" nzBordered nzSize="small"
          style="max-height: calc(100vh / 2); overflow: auto">
        <li nz-list-item *ngFor="let item of ROLE_TYPES" nzNoFlex class="roles">
          <ul nz-list-item-actions>
            <nz-list-item-action>
              <a nz-popconfirm
                 [nzPopconfirmTitle]="checkExistRole(item.value, selectedMenu) ? 'Bạn có chắc chắn bỏ assign role này?' : 'Bạn có chắc chắn assign role này?'"
                 (nzOnConfirm)="removeAssignRole(item.value)"
                 nzCancelText="Hủy"
                 nzOkText="Chắc chắn"
                 nzPopconfirmPlacement="topLeft">
                <i nz-icon [nzType]="checkExistRole(item.value, selectedMenu) ? 'check-circle' : 'info-circle'"
                   [nzTheme]="'twotone'"
                   class="font-size-22"
                   [nzTwotoneColor]="checkExistRole(item.value, selectedMenu) ? '#52c41a' : '#fcbf49'"></i>
              </a>
            </nz-list-item-action>
          </ul>
          <nz-list-item-meta>
            <nz-list-item-meta-title>
              <p><strong>{{ item.name }}</strong></p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </li>
      </ul>
    </div>
  </div>
</nz-card>

